export enum MaloupePlatformKey {
    APPLE = 'apple',
    BING = 'bing',
    FACEBOOK = 'facebook',
    FOURSQUARE = 'foursquare',
    GMB = 'gmb',
    INSTAGRAM = 'instagram',
    TRIPADVISOR = 'tripadvisor',
}
